import { apolloClient } from "@/plugins/vue-apollo.js";

const createCurrency = (_variables) => {
  // , limit, skip
  let responseFromApi;
  let variables = _variables;
  responseFromApi = apolloClient
    .mutate({
      mutation: require("@/settings/api/mutations/currency/create_currency.graphql"),
      variables: variables,
      update: (store, { data }) => {
        const query = {
          query: require("@/settings/api/queries/currency/get_all_currencies.graphql"),
          variables: {
            input: {
              limit: 10,
              skip: 0
            },
            filter: {
              searchKey: ''
            }
          }
        };
        let allCurrency = store.readQuery(query);
        allCurrency.getAllCurrency.currencies.unshift(data.createCurrency); //push to top
        store.writeQuery({
          ...query,
            data: allCurrency,
        });
      }
    })
    .catch(error => {
      return error;
    });
  return responseFromApi;
};
export { createCurrency };
